import { createMakeStyles } from 'tss-react';
import { useTheme } from '@material-ui/core';

const { makeStyles } = createMakeStyles({ useTheme });

export const useStyles = makeStyles()(theme => ({
  card: {
    height: '100%',
    width: '100%',
  },

  tooltip: {
    float: 'right',
    color: theme.palette.primary.main,
  },

  extraInfo: {
    float: 'right',
  },

  content: {
    margin: '0',
    padding: '0',
    height: '100%',
    textAlign: 'center',
    alignContent: 'flex-start',
    '&.MuiCardContent-root': {
      padding: '0',
      margin: '0',
    },
  },
}));
